export const featureArea = {
    seoIntelligence: "seo-intelligence",
    genAI: "genAI",
    adIntelligence: "adIntelligence",
} as const;

export type FeatureArea = (typeof featureArea)[keyof typeof featureArea];

export const featureInfo: Record<FeatureArea, string[]> = {
    [featureArea.seoIntelligence]: [
        "buyer_journey.switch_package.feature.organic_search.title",
        "buyer_journey.switch_package.feature.keyword_research.title",
        "buyer_journey.switch_package.feature.rank_tracker.title",
        "buyer_journey.switch_package.feature.site_audit.title",
    ],
    [featureArea.genAI]: [
        "buyer_journey.switch_package.feature.ai_brand.title",
        "buyer_journey.switch_package.feature.prompts.title",
        "buyer_journey.switch_package.feature.sentiment_analysis.title",
        "buyer_journey.switch_package.feature.ai_traffic.title",
    ],
    [featureArea.adIntelligence]: [
        "buyer_journey.switch_package.feature.campaign_insights.title",
        "buyer_journey.switch_package.feature.social_insights.title",
        "buyer_journey.switch_package.feature.demand_signals.title",
        "buyer_journey.switch_package.feature.ad_spend.title",
    ],
};
